module.exports = __webpack_public_path__ + "img/sign_for_camelot.19b0f963.jpg";